import { gql } from '@apollo/client';

export const GenericTaskManyCount = gql`
  query GenericTaskManyCount($filter: FilterFindManyGenericTaskInput) {
    genericTaskCount(filter: $filter)
  }
`;
